// Libraries
import React from 'react';

// Supermove
import {Styled, Space} from '@supermove/components';
import {UrlFiltersType} from '@supermove/hooks';

// App
import Badge from '@shared/design/components/Badge';
import {ProjectDetailsFiltersType} from '@shared/modules/Project/components/widgets/ProjectDetailsWidget';
import {ProjectEventLogFiltersType} from '@shared/modules/Project/components/widgets/ProjectEventLogWidget';
import {ProjectWidgetKindType} from '@shared/modules/Project/enums/ProjectWidgetKind';

const Row = Styled.View`
  flex-direction: row;
`;

export const SalesLeadsTabKinds = {
  ME: 'ME',
  COMPANY: 'COMPANY',
};

export type SalesLeadsFilterKeys = {
  page: number;
  userKind: string;
  searchQuery: string;
  moveStartDate: string;
  moveEndDate: string;
  teamMemberIds: string[];
  stage: string;
  view: string;
  widget: ProjectWidgetKindType;
  projectUuid: string;
  urlFilters: SalesLeadsFiltersType;
} & ProjectDetailsFiltersType &
  ProjectEventLogFiltersType;

export type SalesLeadsFiltersType = UrlFiltersType<SalesLeadsFilterKeys>;

export const LoadingStageTabs = () => {
  return (
    <React.Fragment>
      <Row style={{paddingLeft: 24}}>
        <Badge.Loading />
        <Space width={24} />
        <Badge.Loading />
        <Space width={24} />
        <Badge.Loading />
        <Space width={24} />
        <Badge.Loading />
        <Space width={24} />
        <Badge.Loading />
      </Row>
      <Space height={4} />
    </React.Fragment>
  );
};
